import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {
  ChartFilter,
  ChartInput
} from '../frequency-view-chart-filters-container/frequency-view-chart-filters-container.component';

@Component({
  selector: 'asax-frequency-view-frequency-view-chart-filter-molecules',
  templateUrl: './frequency-view-chart-filter-molecules.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrequencyViewChartFilterMoleculesComponent implements OnInit, OnChanges {
  @Input() value: string;
  @Input() isDisabled: boolean;
  @Input() chartInput: ChartInput;

  @Output() outFilter = new EventEmitter<ChartFilter>();

  valueToDisplay: string;
  valueSubject = new Subject<string>();

  ngOnInit(): void {
    this.valueSubject.asObservable().pipe(
      tap(() => this.buildValue()),
      tap(() => this.buildValueToDisplay()),
      tap(() => this.emitFilter())
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && this.value !== undefined && this.value != null) {
      this.selectDropdownItemsFromValue();
      this.valueChanged();
    }
  }

  valueChanged(): void {
    this.valueSubject.next(undefined);
  }

  buildValue(): void {
    this.value = this.chartInput.dropdownItems
      .filter(({selected}) => !!selected)
      .map(({value}) => value)
      .join(',');
  }

  buildValueToDisplay(): void {
    const numberOfMoleculesSelected = this.chartInput.dropdownItems
      .filter(({selected}) => !!selected)
      .length;

    if (numberOfMoleculesSelected) {
      this.valueToDisplay = `${numberOfMoleculesSelected} selected`;
    } else {
      this.valueToDisplay = '';
    }
  }

  selectDropdownItemsFromValue(): void {
    const dropdownItemsSelected: string[] = this.value.split(',').map(token => token.trim());
    this.chartInput?.dropdownItems.forEach(dropdownItem => {
        if (dropdownItemsSelected.includes(dropdownItem.value)) {
          dropdownItem.selected = true;
        } else {
          dropdownItem.selected = false;
        }
      }
    );
  }

  clearSearchInputValue(): void {
    this.chartInput.dropdownItems.forEach(dropdownItem => dropdownItem.selected = false);
    this.valueChanged();
  }

  emitFilter(): void {
    const filter = {
      id: this.chartInput.id,
      value: this.value,
      valueParsed: this.value,
      valueToDisplay: this.valueToDisplay,
      label: this.chartInput.label,
      isInvalid: false,
      elasticParserType: this.chartInput.elasticParserType
    };

    this.outFilter.emit(filter);
  }
}
